<!-- полоса загрузки при изменении поля ввода -->
<div class="loading-bar">
    @if (loadingSaveForm()){
        <mat-progress-bar mode="indeterminate" data-testid="loading-bar-order-executor-form"></mat-progress-bar>
    }
</div>

<div class="flex a-center" >
    <mat-icon (click)="openActual()">arrow_back</mat-icon>
    <h4 data-testid="order-executor-title">Заявка {{order.data.id}}</h4>
</div>
@if (loading()) {
    <app-loader [isLoading]="loading()" data-testid="loading-bar-order-executor-form"/>
} @else {
    <form class="flex-column" [formGroup]="orderForm" appFocusOnFirstErrorField (ngSubmit)="changeStatus(OrderStatusEnum.done); $event.preventDefault()">
        <span>Контактные данные:</span>
        <mat-card class="p-relative" style="margin-bottom: 20px">
            <mat-card-header>
                <mat-card-title>{{order.data.contact.firstName}} {{order.data.contact.lastName}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p class="mrt-0">Номер телефона: {{order.data.contact.phone}}</p>
                <p>Адрес: {{order.data.addressDetails || order.data.location.address}}</p>
            </mat-card-content>
        </mat-card>

        <mat-label>Период выполнения:</mat-label>
            <p class="m-0 font-gilroy-regular">
                {{ order.data.dateFrom | date:'dd.MM.yyyy' }}
                <span class="mrl-0-5">{{order.data.dateFrom | date:'HH:mm'}}</span>
                - {{ order.data.dateTo | date:'HH:mm' }}
            </p>
        @if (orderForm.controls.additionalInfo.value){
            <div class="mrt-1">
                <mat-label>Дополнительная информация:</mat-label>
                <p class="m-0 font-gilroy-regular">{{orderForm.controls.additionalInfo.value}}</p>
            </div>
        }

        @if (orderForm.controls.agreement.value) {
            <div class="mrt-1">
                <mat-label>Договор:</mat-label>
                <p class="m-0">{{orderForm.controls.agreement.value}}</p>
            </div>
        }

        <div class="mrt-1">
            <div class="content-flex">
                <mat-label>Проект:</mat-label>
                <p class="m-0 font-gilroy-regular">{{order.data.project.name}}</p>
            </div>
            <div class="content-flex">
                <mat-label>Группа:</mat-label>
                <p class="m-0 font-gilroy-regular">{{order.data.group?.name}}</p>
            </div>
        </div>

        <mat-form-field appearance="fill" class="mrt-1">
            <mat-label>Комментарии к заявке</mat-label>
            <input matInput formControlName="description" (change)="saveControl()" />
        </mat-form-field>

        <span>Запланированные работы:</span>
        <div class="mrt-0-5 mrb-1" formArrayName="orderPrices">
            @for (control of orderForm.controls.orderPrices.controls; track control; let i = $index) {
                <mat-card>
                    @if (isEditOrderPrice.get(i)) {
                        @if (order.data.status === OrderStatusEnum.atwork || order.data.status === OrderStatusEnum.done) {
                            <div class="tx-right">
                                <mat-icon (click)="toggleEditOrderPrice(i)" class="mrt-0-5 icon-price" data-testid="edit-order-price-button">edit</mat-icon>
                            </div>
                        }
                        <div class="py-1 px-0-3">
                            <div class="content-flex">
                                <mat-label>Работа:</mat-label>
                                <p class="m-0 font-gilroy-regular" data-testid="price-name-p">{{order.data.orderPrices[i].price.work.name}} {{order.data.orderPrices[i].price.category.name }}</p>
                            </div>
                            @if (priceWithoutItems(control.get('priceId')?.value)) {
                                <div class="content-flex">
                                    <mat-label>Оборудование:</mat-label>
                                    <p class="m-0 font-gilroy-regular">{{order.data.orderPrices[i].item?.name}}</p>
                                </div>
                            }
                            <div class="content-flex">
                                <mat-label>Количество:</mat-label>
                                <p class="m-0 font-gilroy-regular">{{order.data.orderPrices[i].quantity}}</p>
                            </div>
                            <div class="content-flex">
                                <mat-label>Стоимость:</mat-label>
                                <p class="m-0 font-gilroy-regular">{{ getRowTotal(control) }}</p>
                            </div>
                        </div>
                    } @else {
                        <mat-card-content class="px-0-3 pt-1-0">
                            <div>
                                <app-order-price-form class="w-100" [formGroup]="control" [discountControl]="orderForm.controls.discount"></app-order-price-form>
                                @if (order.data.status === OrderStatusEnum.atwork || order.data.status === OrderStatusEnum.done) {
                                    <div class="flex j-space-between mrt-1">
                                        @if (control.get('priceId')?.value && control.get('itemId')?.value !== 0 || !(priceWithoutItems(control.get('priceId')?.value))) {
                                            <mat-icon (click)="applyEditOrderPrice(i)" class="icon-price" data-testid="apply-edit-order-price-button">check</mat-icon>
                                        } @else {
                                            <mat-error>Укажите вид работы и оборудование (если оно необходимо)</mat-error>
                                        }
                                        <mat-icon (click)="removeOrderPrice(i)" class="icon-price" data-testid="remove-order-price-button">delete_forever</mat-icon>
                                    </div>
                                }
                            </div>
                        </mat-card-content>
                    }
                </mat-card>
            }
            <button type="button" mat-button [disabled]="!orderForm.controls.orderPrices.valid" (click)="addOrderPrice()" data-testid="add-order-price-button">Добавить работу</button>
        </div>

        @if (order.data.discount) {
            <span>К даной заявке применена СКИДКА</span>
        }

        <mat-form-field appearance="fill">
            <mat-label>Общая сумма</mat-label>
            <input matInput [value]="totalCostValue" readonly data-testid="total-cost-value-input" [disabled]="order.data.status !== OrderStatusEnum.atwork && order.data.status !== OrderStatusEnum.done"/>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Предоплата</mat-label>
            <input matInput formControlName="prepayment" type="number" readonly/>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Полученная оплата</mat-label>
            <input matInput formControlName="amountPaid" type="number" min="0" step="1" (change)="saveControl()"/>
        </mat-form-field>

        @if (order.data.project.id) {
            <app-order-custom-fields  [customFieldsParamsControl]="orderForm.controls.customFieldsParams" [projectId]="order.data.project.id" [status]="order.data.status" (changeForm)="updateCustomFieldsControl()" (customFieldInvalid)="customFieldInvalid = $event"></app-order-custom-fields>
        }

        @if (orderForm.get('amountPaid')!.hasError('amountPaidMustBeZero')) {
            <mat-error>
                Предоплата внесена целиком.
            </mat-error>
        }
        @if (orderForm.get('amountPaid')!.hasError('amountPaidExceedsTotal')) {
            <mat-error>
                Сумма оплачено не может превышать общую стоимость.
            </mat-error>
        }

        <mat-checkbox formControlName="conditionsCheck" (click)="saveControl()" data-testid="conditions-check-checkbox">
            Проверка наличия тяги в дымовых и вентиляционных каналах, Состояния соединительных труб с
            дымовым каналом: тяга есть, соединения дымоотводящих труб с дымовым каналом
            герметичны. Инструктаж потребителей газа по безопасному пользованию газом при
            удовлетворении коммунально-бытовых нужд проведен, копия инструктажа вручена.
        </mat-checkbox>

        @if (order.data.status === OrderStatusEnum.atwork) {
            <span class="disabled">Прикрепить файлы:</span>
            <input type="file" accept="image/*,video/*" capture="environment" (change)="updateFiles($event)" multiple data-testid="add-file-input">
            @if (order.data.files?.length) {
                <span [style.color]="orderForm.controls.files.disabled ? '#c5c3c3' : '#000'" class="mrb-1">Ссылки на ранее прикрепленные фото/видео:</span>
                @for (file of order.data.files; track file; let i = $index) {
                    <a [href]="fileUrls[i]" [download]="file.name + '.' + file.format" data-testid="file-name-a">
                        {{file.name}}.{{file.format}}
                    </a>
                }
            }
        } @else {
            <app-saving-files class="mrt-1 mrb-1" [formCtrl]="orderForm.controls.files" ></app-saving-files>

            @if (order.data.files?.length) {
                <span [style.color]="orderForm.controls.files.disabled ? '#c5c3c3' : '#000'">Ссылки на ранее прикрепленные фото/видео:</span>
                @for (file of order.data.files; track file; let i = $index) {
                    <a [href]="fileUrls[i]" [download]="file.name + '.' + file.format" data-testid="file-name-a">
                        {{file.name}}.{{file.format}}
                    </a>
                }
            }
        }

        @if (offlineService.offline()) {
            @if (fileOffLine().length) {
                @if (!order.data.files?.length) {
                    <span [style.color]="orderForm.controls.files.disabled ? '#c5c3c3' : '#000'">Ссылки на ранее прикрепленные фото/видео:</span>
                }
                @for (file of fileOffLine(); track file; let i = $index) {
                    <a [href]="file.buffer" [download]="file.name + '.' + file.format" data-testid="file-name-a">
                        {{file.name}}.{{file.format}}
                    </a>
                }
            }
        }

        <div class="mrt-1 flex-column">
            <span [style.color]="orderForm.controls.signature.disabled ? '#c5c3c3' : '#000'">Подпись заказчика</span>
            <app-signature-pad  class="mrt-0-5" [formCtrl]="orderForm.controls.signature" (signApply)="updateSignature()"></app-signature-pad>
            @if (orderForm.controls.signature.invalid) {
                <span class="mrb-1">* заполните поле "Подпись заказчика" и подтвердите её</span>
            }
        </div>

        <section class="flex">
            @if (order.data.status === OrderStatusEnum.ready) {
                <button
                    class="status_onway size-1"
                    type="button"
                    (click)="changeStatus(OrderStatusEnum.onway)"
                    data-testid="status-onway-button"
                >Выехал
                </button>
            }

            @if (
                order.data.status === OrderStatusEnum.onway ||
                order.data.status === OrderStatusEnum.reject
                ) {
                <button
                    class="status_atwork size-1"
                    type="button"
                    (click)="changeStatus(OrderStatusEnum.atwork)"
                    data-testid="status-atwork-button"
                >
                    {{order.data.status === OrderStatusEnum.onway ? 'Прибыл' : 'Вернуть в работу'}}
                </button>
            }

            @if (order.data.status === OrderStatusEnum.atwork) {
                <button
                    class="status_done size-1"
                    type="submit"
                    data-testid="status-done-button"
                >Выполнено
                </button>
            }

            @if (order.data.status === OrderStatusEnum.done) {
                <button
                    class="status_ready size-1"
                    type="button"
                    [disabled]="!canEdit"
                    (click)="updateOrder()"
                    data-testid="save-order-button"
                >Сохранить изменения
                </button>
            }

            @if (
                order.data.status !== OrderStatusEnum.done &&
                order.data.status !== OrderStatusEnum.reject
                ) {
                <button
                    class="status_reject size-1"
                    type="button"
                    (click)="rejectOrder()"
                >Отказ
                </button>
            }
        </section>
    </form>
}
